import { render, staticRenderFns } from "./cabs-in-goa.vue?vue&type=template&id=03cf4351&scoped=true"
import script from "./cabs-in-goa.vue?vue&type=script&lang=js"
export * from "./cabs-in-goa.vue?vue&type=script&lang=js"
import style0 from "./cabs-in-goa.vue?vue&type=style&index=0&id=03cf4351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf4351",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
